import React from "react";
import "../Layouts.css";
import FeaturedList from "./FeaturedList";

export default class App extends React.Component {
  render() {
    return (
      <div className="Main">
        <FeaturedList isMobile={this.props.isMobile} />
      </div>
    );
  }
}
